var _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUtilityPlate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 713,
    height: 392,
    viewBox: "0 0 713 392",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6296 26.131C20.4484 11.5564 32.5057 0.15744 47.1033 0.15744H666.49C681.087 0.15744 693.145 11.5564 693.964 26.131L712.885 362.94C713.772 378.719 701.216 392 685.412 392H28.1815C12.3776 392 -0.178672 378.719 0.707789 362.94L19.6296 26.131Z",
    fill: "#181816"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6296 26.131C20.4484 11.5564 32.5057 0.15744 47.1033 0.15744H666.49C681.087 0.15744 693.145 11.5564 693.964 26.131L712.885 362.94C713.772 378.719 701.216 392 685.412 392H28.1815C12.3776 392 -0.178672 378.719 0.707789 362.94L19.6296 26.131Z",
    fill: "url(#paint0_linear_2_9)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2_9",
    x1: 356.796,
    y1: 0.15744,
    x2: 356.796,
    y2: 392,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F0E0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F0E0D",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUtilityPlate);
export default __webpack_public_path__ + "static/media/utility-plate.6d0d7729e0e72595098d8ac4b9bb3ce0.svg";
export { ForwardRef as ReactComponent };